/**
 * Met à jour les compteurs des cartes .fins-serie-coll-cards en comptant
 * les .grid__item produits réellement rendus dans les sections .collection-findeserie.
 */
(function () {
  function countCardsForHandle(handle) {
    if (!handle) return 0;
    var escaped = handle.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    var sections = document.querySelectorAll(
      '.collection-findeserie[data-fins-serie-source-collection="' + escaped + '"]'
    );
    var total = 0;
    sections.forEach(function (section) {
      var grid = section.querySelector('.collection-home .grid.grid--uniform');
      if (!grid) return;
      var cards = grid.querySelectorAll('.grid__item[data-product-id]');
      total += cards.length;
    });
    return total;
  }

  function syncFinsSerieCardCounts() {
    var nav = document.querySelector('.fins-serie-coll-cards');
    if (!nav) return;

    nav.querySelectorAll('[data-fins-serie-nav-collection]').forEach(function (item) {
      var handle = item.getAttribute('data-fins-serie-nav-collection');
      var n = countCardsForHandle(handle);

      var countEl = item.querySelector('.js-fins-serie-card-count');
      var labelEl = item.querySelector('.js-fins-serie-card-count-label');
      if (countEl) {
        countEl.textContent = String(n);
      }
      if (labelEl) {
        labelEl.textContent = n === 1 ? ' produit' : ' produits';
      }

      var link = item.querySelector('a.fins-serie-coll-cards__card');
      var titleEl = item.querySelector('.fins-serie-coll-cards__title');
      if (link && titleEl) {
        var title = titleEl.textContent.trim();
        link.setAttribute('aria-label', title + ' — ' + n + (n === 1 ? ' produit' : ' produits'));
      }

      item.classList.toggle('fins-serie-coll-cards__item--empty', n === 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFinsSerieCardCounts);
  } else {
    syncFinsSerieCardCounts();
  }

  document.addEventListener('shopify:section:load', function () {
    syncFinsSerieCardCounts();
  });
})();
